import './LoadingButton.css';
export default {
    "root": "LoadingButton_root__156r8",
    "animation": "LoadingButton_animation__156r8",
    "rotating": "LoadingButton_rotating__156r8",
    "hidden": "LoadingButton_hidden__156r8"
};
